import { defineStore } from 'pinia'
import {
  loadResponsesAPI,
  updateResponseAPI
} from '@/services/responses-service'
import { setSurveyFinishedAPI } from '@/services/surveys-service'
import { requestTypes } from '@/constants/request-types'

export const useResponsesStore = defineStore('responses-store', {
  state: () => ({
    error: {},
    loading: {},
    responses: []
  }),
  getters: {
    getResponses: (state) => {
      return state.responses
    }
  },
  actions: {
    clear() {
      this.loading = {}
      this.error = {}
      this.responses = []
    },
    async loadResponsesAction({ surveyName }) {
      this.loading[requestTypes.RESPONSES] = true
      try {
        this.responses = await loadResponsesAPI({ surveyName })
      } catch (error) {
        this.error = error
        throw error
      } finally {
        this.loading[requestTypes.RESPONSES] = false
      }
    },
    async confirmUserResponsesAction({
      surveyName,
      responses,
      surveyFinishedParams
    }) {
      try {
        // update all actions to have done: true
        for (const response of responses) {
          await updateResponseAPI({
            surveyName,
            categoryName: response.categoryName,
            params: response.params
          })
        }
        // sends thank you email to user
        if (surveyFinishedParams.confirm) {
          await setSurveyFinishedAPI({
            surveyName,
            ...surveyFinishedParams
          })
        }
      } catch (error) {
        this.error = error
        throw error
      }
      this.responses = await loadResponsesAPI({ surveyName })
    },
    async updateUserResponsesAction({ surveyName, responses }) {
      // TODO: chunks if necessary?
      try {
        for (const response of responses) {
          await updateResponseAPI({
            surveyName,
            categoryName: response.categoryName,
            params: response.params
          })
        }
      } catch (error) {
        this.error = error
        throw error
      }
      this.responses = await loadResponsesAPI({ surveyName })
    }
  }
})
